import { Fragment } from 'react';

import Divider from '@/components/common/Divider';
import ProductCardCU from '@/components/categ/CategCU/ProductCardCU';
import { useScreenSizeContext } from '@/components/ScreenSize.context';

import styles from './ProductListCU.module.scss';

export const ProductListCU = ({ productList, computeCurrentItem, isCU }) => {
  const isDesktop = useScreenSizeContext().isDesktop;
  const isMobile = useScreenSizeContext().isMobile;

  const dividerModulo = isMobile ? 2 : isDesktop ? 4 : 3;

  return (
    <div className={styles.container} data-test-id="product-list-cu">
      {productList?.map((product, index) => (
        <Fragment key={index}>
          {index % dividerModulo === 0 && <Divider spacing={16} className={styles.divider} />}
          <div key={product.id} className={styles.card}>
            <ProductCardCU product={product} index={index} currentItem={() => computeCurrentItem(product)} isCU={isCU} />
          </div>
        </Fragment>
      ))}
      <Divider spacing={16} className={styles.divider} />
    </div>
  );
};

export default ProductListCU;
